import React from 'react';
import { StarIcon, MoreVerticalIcon } from 'lucide-react';
import { mockApps } from '../../utils/mockData';
import { getIcon } from '../../utils/iconUtils';
import { useNavigate } from 'react-router-dom';
interface AppListViewProps {
  onOpenApp: (appId: string) => void;
  createAppTile?: any;
}
export const AppListView = ({
  onOpenApp,
  createAppTile
}: AppListViewProps) => {
  const navigate = useNavigate();
  // Mobile card view
  const MobileListView = () => <div className="md:hidden space-y-4" data-id="element-290">
      {mockApps.map(app => <div key={app.id} className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm" onClick={() => navigate(`/app-interface/${app.id}`)} data-id="element-291">
          <div className="flex items-center space-x-3" data-id="element-292">
            <div className={`${app.iconBg} w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0`} data-id="element-293">
              {getIcon(app.icon)}
            </div>
            <div className="flex-1 min-w-0" data-id="element-294">
              <h3 className="font-medium text-gray-900 truncate" data-id="element-295">
                {app.title}
              </h3>
              <p className="text-sm text-gray-500 truncate" data-id="element-296">{app.author}</p>
            </div>
            <button className="p-2 text-gray-400 hover:text-gray-600" data-id="element-297">
              <MoreVerticalIcon className="h-5 w-5" data-id="element-298" />
            </button>
          </div>
          <div className="mt-3 flex items-center justify-between" data-id="element-299">
            <div className="flex items-center" data-id="element-300">
              <StarIcon className="h-4 w-4 text-amber-400 fill-amber-400" data-id="element-301" />
              <span className="ml-1 text-sm font-medium" data-id="element-302">{app.rating}</span>
            </div>
            <div className="text-sm text-gray-500" data-id="element-303">{app.category}</div>
            <div className="text-sm text-gray-500" data-id="element-304">{app.updated}</div>
          </div>
        </div>)}
    </div>;
  // Desktop table view
  const DesktopListView = () => <div className="hidden md:block overflow-hidden bg-white rounded-lg border border-gray-200" data-id="element-305">
      <div className="overflow-x-auto" data-id="element-306">
        <table className="min-w-full divide-y divide-gray-200" data-id="element-307">
          <thead className="bg-gray-50" data-id="element-308">
            <tr data-id="element-309">
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-310">
                App
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-311">
                Category
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-312">
                Rating
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-313">
                Last Used
              </th>
              <th scope="col" className="relative px-6 py-3" data-id="element-314">
                <span className="sr-only" data-id="element-315">Actions</span>
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200" data-id="element-316">
            {mockApps.map(app => <tr key={app.id} className="hover:bg-gray-50 cursor-pointer" onClick={() => navigate(`/app-interface/${app.id}`)} data-id="element-317">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-318">
                  <div className="flex items-center" data-id="element-319">
                    <div className={`${app.iconBg} w-8 h-8 rounded-lg flex items-center justify-center`} data-id="element-320">
                      {getIcon(app.icon)}
                    </div>
                    <div className="ml-4" data-id="element-321">
                      <div className="text-sm font-medium text-gray-900" data-id="element-322">
                        {app.title}
                      </div>
                      <div className="text-sm text-gray-500" data-id="element-323">{app.author}</div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-324">
                  <span className="text-sm text-gray-900" data-id="element-325">{app.category}</span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-326">
                  <div className="flex items-center" data-id="element-327">
                    <StarIcon className="h-4 w-4 text-amber-400 fill-amber-400" data-id="element-328" />
                    <span className="ml-1 text-sm text-gray-900" data-id="element-329">
                      {app.rating}
                    </span>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-330">
                  {app.updated}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-331">
                  <button className="text-gray-400 hover:text-gray-600 p-2" onClick={e => {
                e.stopPropagation();
                // Handle menu click
              }} data-id="element-332">
                    <MoreVerticalIcon className="h-5 w-5" data-id="element-333" />
                  </button>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
  return <>
      <MobileListView data-id="element-334" />
      <DesktopListView data-id="element-335" />
    </>;
};